import { render } from "./CategoryDelete.vue?vue&type=template&id=324887fe&ts=true"
import script from "./CategoryDelete.vue?vue&type=script&lang=ts"
export * from "./CategoryDelete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__